import React from "react";
import SideNav from "@hid-galaxy-ui/galaxy-react/components/SideNav";
import { Outlet, useLocation, useNavigate } from "react-router";
import { useAppDispatch, useAppSelector } from "../../../redux";
import { useMediaQuery } from "@mui/material";
import BottomNavigationMenu from "../../../common/components/BottomNavigationMenu/BottomNavigationMenu";
import "./PartnerPOCDashboard.scss";

const PartnerPOCDashboard = () => {
  const { loggedUserDetail } = useAppSelector((state) => state.auth);
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const location = useLocation();
  const pathName = location.pathname;
  const pathNameArray = pathName.split("/");
  const isMobile = useMediaQuery("(max-width:1023px)");

  React.useEffect(() => {
    const element = document.getElementById(
      pathNameArray[pathNameArray.length - 1]
    );
    element?.click();
  }, [pathName]);

  const onNodeClick = (e: any, key: any) => {
    navigate(key);
  };

  const navItems = [
    {
      iconName: "listCheck",
      key: "feature-list",
      title: "Feature Management",
    },
    {
      iconName: "triangleExclamation",
      key: "incident-list",
      title: "Incident Management",
    },
    {
      iconName: "arrowsRotate",
      key: "health-checkup",
      title: "Health Checkups",
    },
    {
      iconName: "table",
      key: "feature-comparison",
      title: "Feature Comparison",
    },
  ];

  const mobileMenuData = [
    {
      iconName: "listCheck",
      key: "feature-list",
      title: "Feature Management",
    },
    {
      iconName: "triangleExclamation",
      key: "incident-list",
      title: "Incident Management",
    },
  ];

  const mobileMoreMenuData = [
    {
      iconName: "arrowsRotate",
      key: "health-checkup",
      title: "Health Checkups",
    },
    {
      iconName: "table",
      key: "feature-comparison",
      title: "Feature Comparison",
    },
  ];

  return (
    <div className="partner-poc-dashboard-container">
      {isMobile ? (
        <BottomNavigationMenu
          menuData={mobileMenuData}
          moreMenuDataEnabled={true}
          moreMenuData={mobileMoreMenuData}
        />
      ) : (
        <SideNav
          id="sidenav"
          mode="Colapsed"
          isToggle={false}
          selected={pathNameArray[pathNameArray.length - 1]}
          navItems={navItems}
          onNodeClick={(e, key) => onNodeClick(e, key)}
        />
      )}
      <div className="outlet-view">
        <Outlet />
      </div>
    </div>
  );
};

export default PartnerPOCDashboard;
